// extracted by css-extract-rspack-plugin
export default {"loadingWrap":"loadingWrap-k9gPRU","loader":"loader-WNayWL","load4":"load4-YNsilK"};